import { useToast } from 'vuestic-ui'

const { init } = useToast()

export function showCreateSuccess(message: string = 'Tạo thành công') {
  init({ message, color: 'success' })
}

export function showUpdateSuccess(message: string = 'Cập nhật thành công') {
  init({ message, color: 'success' })
}

export function showDeleteSuccess(message: string = 'Xóa thành công') {
  init({ message, color: 'success' })
}

export function showSuccess(message: string = 'Thành công') {
  init({ message, color: 'success' })
}

export function showError(message: string = 'Có lỗi xảy ra') {
  init({ message, color: 'danger' })
}

export function showInfo(message: string) {
  init({ message, color: 'info' })
}

export function showEnterDataInValid(message: string = 'Dữ liệu nhập không hợp lệ') {
  init({ message, color: 'danger' })
}
